import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  currentUrl: string;
  showStickyHeader = false;
  showCaseDetailStickyHeader = false;
  caseDetailId = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    // Obtener la URL inicial
    this.currentUrl = this.router.url;
    this.updateStickyHeaderVisibility();

    // Escuchar cambios de ruta
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentUrl = this.router.url;
      this.updateStickyHeaderVisibility();
    });
  }

  private updateStickyHeaderVisibility(): void {
    this.showStickyHeader = this.currentUrl.includes('/risks/');
    this.showCaseDetailStickyHeader = this.currentUrl.includes('/case-detail/');

    // Obtener idCase de los parámetros de la ruta
    if (this.showCaseDetailStickyHeader) {
      let route = this.activatedRoute.firstChild;
      while (route?.firstChild) {
        route = route.firstChild;
      }
      this.caseDetailId = route?.snapshot.params['idCase'] || '';
    } else {
      this.caseDetailId = '';
    }
  }

}
